import type { Action } from "svelte/action";

type Parameters = {
  validationMessage?: string;
  hint?: string;
  maxLength?: number;
  minLength?: number;
};

/**
 *
 *
 *
 *
 *
 */
export const ariaDescriptionWithValidation: Action<HTMLElement, Parameters> = (
  node,
  parameters,
) => {
  const update = ({ validationMessage, hint, maxLength, minLength }: Parameters): void => {
    const labeledValidationMessage = validationMessage ? `Fehler: ${validationMessage}` : "";
    const minLengthMessage = minLength ? `Mindestens ${minLength} Zeichen` : "";
    const maxLengthMessage = maxLength ? `Maximal ${maxLength} Zeichen` : "";
    node.setAttribute(
      "aria-description",
      [labeledValidationMessage, hint, minLengthMessage, maxLengthMessage]
        .filter(Boolean)
        .join(". "),
    );
    node.setAttribute("aria-invalid", `${!!validationMessage}`);
  };

  update(parameters);
  return { update };
};
